import React, { useState, useEffect } from 'react'
import { CForm, CFormLabel, CFormInput, CFormText, CFormTextarea, CSpinner, CFormSelect, CButton, CRow, CCol, CFormCheck } from '@coreui/react'
import CustomDropDown from '../../components/shared/CustomDropdown.jsx'
import FacilityCRUD from '../../services/general/getFacilityData.api.js'
import countyData from './CountyData.json'
import CustomDatePickingFormat from '../../components/shared/CustomDatePickingFormat.jsx'
// Example data
const exampleData = countyData

const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
const FacilityForm = ({
  initialName = '',
  Lat = '',
  Lng = '',
  initialType = '',
  typeOptions = [],
  Mode = '',
  initialAddress = '',
  facilityID = '',
  onSubmit,
  Status = '',
  Sister = false,
  ParentCompany = '',
  initialCounty = '',
  initialState = '',
  initialCity = '',
  initialDays = '',
  initialParentCompany = '',
  initialOtherDetails = {},
  isPecosAddedProps = false,
  pecosDateProps = '',
}) => {
  const [name, setName] = useState(initialName)
  const [address, setAddress] = useState(initialAddress)
  const [options, setOptions] = useState(typeOptions)
  const [type, setType] = useState(initialType || (typeOptions.length > 0 ? typeOptions[0] : ''))
  const [isDataRefetched, setDataRefetched] = useState(false)
  const [county, setCounty] = useState(initialCounty)
  const [state, setState] = useState(initialState)
  const [city, setCity] = useState(initialCity)
  const [days, setDays] = useState([])
  const [parentCompanyName, setParentCompanyName] = useState(initialParentCompany || ParentCompany || '')
  const [addedTopecos, setAddedTopecos] = useState(isPecosAddedProps)
  const [pecosDate, setPecosDate] = useState(pecosDateProps)
  const [modalVisible, setModalVisible] = useState(true)

  useEffect(() => {
    if (county) {
      const selectedData = exampleData[county]
      if (selectedData) {
        setState(selectedData.state)
        setCity(selectedData.city)
      } else {
        setState('')
        setCity('')
      }
    } else {
      setState('')
      setCity('')
    }
  }, [county])

  useEffect(() => {
    // Setting initial values if they are provided
    setName(initialName)
    setAddress(initialAddress)
    setType(initialType || (typeOptions.length > 0 ? typeOptions[0] : ''))
    setCounty(initialCounty)
    setState(initialState)
    setCity(initialCity)
    setDays(initialDays ? initialDays?.split(',')?.map((day) => day.trim()) : [])
    setParentCompanyName(initialParentCompany || ParentCompany || '')
  }, [initialName, initialAddress, initialType, typeOptions, initialCounty, initialState, initialCity, initialDays, initialParentCompany, ParentCompany])

  const getCoordinates = async (addr) => {
    const geocoder = new window.google.maps.Geocoder()
    let latlong = {}
    try {
      await geocoder.geocode({ address: addr }, (results, status) => {
        if (status === 'OK') {
          const latLng = results[0].geometry.location
          let allAddress = results[0]['address_components']
          let addressDetails = {}

          allAddress.map((obj) => {
            let l = obj['types'][0]
            addressDetails[l] = obj['long_name']
          })

          latlong = { lat: latLng.lat(), lng: latLng.lng(), addressDetails, city: addressDetails['locality'] }
        } else {
          latlong = { lat: null, lng: null, addressDetails: null, city: null }
        }
      })
    } catch (e) {
      console.log(e)
    }

    return latlong
  }

  const handleTypeSelect = (e) => {
    setType(e.target.value)
  }

  const handleDaySelect = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions, (option) => option.value)
    setDays(selectedOptions)
  }

  const availableCounties = Object.keys(exampleData)

  const handleSubmit = async (event) => {
    event.preventDefault()
    setDataRefetched(true)
    let lat = Lat
    let lng = Lng
    let addressDetails = {}
    let otherDetails = { ...initialOtherDetails }

    if (Sister) {
      otherDetails['SisterCompany'] = ParentCompany
    }

    otherDetails['ParentCompany'] = parentCompanyName.trim()

    otherDetails['PecosDate'] = pecosDate

    otherDetails['isPecosAdded'] = addedTopecos

    if (!Lat || Lat == '') {
      let latlng = await getCoordinates(address)
      lat = latlng.lat
      lng = latlng.lng
      addressDetails = latlng.addressDetails
    }

    if (!Status) {
      Status = 'Pending'
    }

    let allDays = days.join(',')

    setCity(addressDetails?.administrative_area_level_1 ? addressDetails?.administrative_area_level_1 : null)
    setState(addressDetails?.administrative_area_level_2 ? addressDetails?.administrative_area_level_2 : null)
    const countyName = Object.keys(exampleData).find((county) => county === addressDetails?.administrative_area_level_2) /// populate the country after finding into the example data objects
    setCounty(countyName || '')

    await FacilityCRUD(Mode === '' ? 'INSERT' : Mode, { id: facilityID, name, type, address, lat, lng, status: Status, addressDetails, city, county, state, days: allDays, otherDetails })
    onSubmit({ id: facilityID, name, type, address, lat, lng, status: Status, addressDetails, city, county, state, days: allDays, otherDetails })
    setDataRefetched(false)
    setModalVisible(false)
  }

  useEffect(() => {
    if (address) {
      const fetchCoordinates = async () => {
        let latlng = await getCoordinates(address)
        setCity(latlng.addressDetails?.locality || '')
        setState(latlng.addressDetails?.administrative_area_level_1 || '')
        const countyName = Object.keys(exampleData).find((county) => county === latlng.addressDetails?.administrative_area_level_2) // populate the country after finding into the example data objects
        setCounty(countyName || '')
      }
      fetchCoordinates()
    }
  }, [address])

  return (
    <>
      <CForm>
        <CRow>
          <CCol md={6}>
            <CFormLabel htmlFor="name">Name</CFormLabel>
            <CFormInput type="text" id="name" placeholder="Enter facility name" value={name} onChange={(e) => setName(e.target.value)} className="mb-3" />
          </CCol>
          <CCol md={6}>
            <CFormLabel htmlFor="type">Type</CFormLabel>
            <CustomDropDown options={options} selected={type} onSelect={handleTypeSelect} />
          </CCol>
        </CRow>
        <CRow>
          <CCol md={6}>
            <CFormLabel htmlFor="parentCompany">Parent Company</CFormLabel>
            <CFormInput type="text" id="parentCompany" placeholder="Enter parent company" value={parentCompanyName} onChange={(e) => setParentCompanyName(e.target.value)} className="mb-3" />
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CFormLabel htmlFor="address">Address</CFormLabel>
            <CFormTextarea type="text" id="address" placeholder="Enter facility address" value={address} onChange={(e) => setAddress(e.target.value)} rows={3} />
            <CFormText className="help-block mb-3">Please enter the full address, including city and zip code.</CFormText>
          </CCol>
        </CRow>
        <CRow>
          <CCol md={6}>
            <CFormLabel htmlFor="county">County</CFormLabel>
            <CFormSelect id="county" value={county} onChange={(e) => setCounty(e.target.value)} className="mb-3">
              <option value="">Select County</option>
              {availableCounties.map((county, index) => (
                <option key={index} value={county}>
                  {county}
                </option>
              ))}
            </CFormSelect>
          </CCol>
          <CCol md={6}>
            <CFormLabel htmlFor="city">City</CFormLabel>
            <CFormInput type="text" id="city" placeholder="City will be auto-selected" value={city} className="mb-3" />
          </CCol>
          <CCol md={6} className="d-flex align-items-center gap-2">
            {/* <CFormLabel className='p-0 m-0 py-4' htmlFor="city">Added to pecos</CFormLabel> */}
            <CFormCheck label="Added to pecos" onChange={(e) => setAddedTopecos(e.target.checked)} id="flexCheckIndeterminate" checked={addedTopecos} />
          </CCol>
          <CCol md={6} className="d-flex flex-column">
            <CFormLabel htmlFor="city">PECOS Added Date</CFormLabel>
            <CustomDatePickingFormat
              value={pecosDate}
              onChange={(dateNew) => {
                setPecosDate(dateNew)
              }}
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol md={6}>
            <CFormLabel htmlFor="state">State</CFormLabel>
            <CFormInput type="text" id="state" placeholder="State will be auto-selected" value={state} className="mb-3" />
          </CCol>
          {/* <CCol md={6}>
            <CFormLabel htmlFor="days">Days</CFormLabel>
            <CFormSelect id="days" multiple size={3} value={days} onChange={handleDaySelect} className="mb-3">
              {daysOfWeek.map((day, index) => (
                <option key={index} value={day}>
                  {day}
                </option>
              ))}
            </CFormSelect>
          </CCol> */}
        </CRow>
      </CForm>

      <CButton color="primary" onClick={handleSubmit}>
        {isDataRefetched ? (
          <>
            <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
            Loading...
          </>
        ) : (
          <>Submit</>
        )}
      </CButton>
      {/* <CButton color="secondary" onClick={() => setModalVisible(false)}>Cancel</CButton> */}
    </>
  )
}

export default FacilityForm

// "{\"id\":515,\"name\":\"Testing Pecos\",\"type\":\"ALF\",\"address\":\"\",\"lat\":null,\"lng\":null,\"status\":\"Pending\",\"addressDetails\":null,\"city\":\"\",\"county\":\"\",\"state\":\"\",\"days\":\"Tuesday,Wednesday,Thursday\",\"otherDetails\":{\"PecosDate\":\"07/01/2025\"}}"
